<template>
  <div class="wrapper">
    <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
      <a href="#" @click.prevent="$router.push({ name: 'historico-inicio' })"><i class="fa fa-angle-left"></i></a>
      Histórico {{ $route.params.name }}
    </h1>
    <object-select-table
      @searchSelected="(e) => getHistory(e)"
      :query="form.query"
      @handleHide="resetForm()"
    ></object-select-table>
    <info-modal></info-modal>
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <span class="mt-2"> </span>
          <b-card header-tag="header" footer-tag="footer">
            <b-form @submit.stop.prevent="onSubmit">
              <b-input-group class="mb-3">
                <b-form-input
                  placeholder="Ingrese número de búsqueda"
                  type="text"
                  v-model="$v.form.query.$model"
                  :state="validateState('query')"
                  id="search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button type="submit" text="Buscar">Buscar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
            <b-row>
              <b-col class="mt-2 text-center">
                <div>
                  <b-spinner class="mb-5" v-if="loading"></b-spinner>
                  <b-alert v-if="message" variant="warning" show>{{ message }}</b-alert>
                  <b-table hover v-if="showTable" :fields="fields" :items="items" small>
                    <template v-slot:cell(history_type)="data">
                      <i class="fa fa-circle"></i>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <history-detail-modal :topic="$route.params.topic" :item="data.item"></history-detail-modal>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import HistoryDetailModal from "./HistoryDetailModal";
import ObjectSelectTable from "./ObjectSelectTable.vue";
import InfoModal from "./InfoModal.vue";
import { required, integer } from "vuelidate/lib/validators";
export default {
  name: "BuscarHistorico",
  components: {
    HistoryDetailModal,
    ObjectSelectTable,
    InfoModal
  },
  data() {
    return {
      form: {
        query: null
      },
      loading: false,
      message: null,
      items: [],
      fields: [
        {
          key: "history_type",
          label: " ",
          thStyle: "width: 5%",
          tdClass: (value) => (value == "+" ? "text-success" : value == "-" ? "text-danger" : "text-warning")
        },
        {
          label: "Descripción",
          key: "description",
          thStyle: "width: 50%",
          class: "text-left"
        },
        {
          label: "Usuario",
          key: "history_user__username",
          thStyle: "width: 15%"
        },
        {
          label: "Fecha/Hora",
          key: "tz_history_date",
          thStyle: "width: 25%"
        },
        {
          label: " ",
          key: "actions",
          thStyle: "width: 10%"
        }
      ]
    };
  },
  computed: {
    showTable() {
      return !this.loading && this.items.length > 0;
    }
  },
  methods: {
    async getHistory(evt) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      thisV.message = null;
      url = `history/${thisV.$route.params.topic}/${evt}/`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.$toast.success(`${thisV.$route.params.name} #${evt} cargado con éxito`, "");
        thisV.loading = false;
        thisV.items = response.data;
        if (thisV.items.length == 0) {
          thisV.message = "No hay historia que mostrar";
        }
      } catch (error) {
        console.log(error);
        if (error.response.status_code != 500) {
          thisV.message = error.response.data.detail;
        } else {
          thisV.$toast.error("Problemas al cargar historia. Error interno.", "");
        }
        thisV.loading = false;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        query: null
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      if (this.$route.params.searcheable) {
        this.$bvModal.show("object-select-table");
        return;
      }
      this.items = [];
      this.message = null;
      this.getHistory(this.form.query);
      this.resetForm();
    }
  },
  validations: {
    form: {
      query: { required }
    }
  }
};
</script>

<style></style>
